import { useQuery, useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
export type PetSettings = {
  pet_color_list: string[];
  breed_list: string[];
};
export const getPetSettings = (): Promise<PetSettings> => {
  return axios.get(`/ref-values`);
};

type QueryFnType = typeof getPetSettings;
export const useGetPetSettings = () => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['petSettings'],
    queryFn: () => getPetSettings(),
  });
};
